.radio-button {
  align-items: center;
  display: grid;
  gap: 0 0.5rem;
  grid-template-columns: auto [label] 1fr;
}

.radio-button__input {
  accent-color: var(--color-navy-600);
}

.radio-button .radio-button__input {
  cursor: pointer;
  margin-top: 0;
}

.radio-button__label {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.radio-button__label::before {
  content: "";
  position: absolute;
  top: 0;
  left: -1rem;
  bottom: 0;
  width: 1rem;
}

.radio-button__description {
  color: var(--color-grey-700);
  grid-area: label;
  margin: 0;
}

.radio-button .radio-button__label {
  width: fit-content;
}

.radio-button :disabled + .radio-button__label {
  color: var(--color-grey-700);
  cursor: unset;
}

.radio-button--gap-large {
  column-gap: 1rem;
}
